var _circle, _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 39.9999,
    r: 29,
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2379_36156)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 35.5,
    stroke: "#585858"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 10.9999C43.992 10.9999 48.4216 12.0803 52.427 14.1546C56.4325 16.229 59.9014 19.2392 62.548 22.9416C65.1946 26.6441 66.9432 30.9332 67.6483 35.4584C68.3535 39.9836 67.9948 44.614 66.6022 48.9704",
    stroke: "#585858",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3092 48.0956V45.7156L39.2126 41.0023C41.2426 39.3689 41.9659 38.1556 41.9659 36.8489C41.9659 35.3323 40.6826 34.3989 39.2359 34.3989C37.5559 34.3989 36.3426 35.2623 35.1759 36.6623L33.2859 34.9123C34.8026 32.9289 36.7392 31.7856 39.3292 31.7856C42.5026 31.7856 44.9292 33.8156 44.9292 36.7789C44.9292 38.9023 43.9492 40.6056 41.1959 42.7289L37.8359 45.4356H45.0926V48.0956H33.3092Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2379_36156",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2379_36156"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoIcon);
export default __webpack_public_path__ + "static/media/two_icon.1f553708fecf266320a50504852b4287.svg";
export { ForwardRef as ReactComponent };